import React from 'react';
import messages from '../../../locale/jsonMessages';
import Layout from '../../../components/Layout/Layout';
import ServicePlanPayment from './ServicePlanPayment';
import { setSiteSettings } from '../../../actions/siteSettings';

export default async function action({ store, params, intl }) {

    const title = intl?.formatMessage(messages.reviewAndPay);
    const isAuthenticated = store.getState().runtime.isAuthenticated;
    let isPaymentActive = store.getState().paymentState.isPaymentActive;
    const { id } = params;
    const [userType, planId] = id.split('-');
    if (!isAuthenticated) return { redirect: '/login' };

    await store.dispatch(setSiteSettings());

    let isServicePlanEnabled = store?.getState()?.siteSettings?.data?.isServicePlanEnabled;
    if (isServicePlanEnabled == 'false') {
        return { redirect: '/user/payout' };
    }
    if (!isPaymentActive) {
        return { redirect: '/users/service-plans/renter' };
    }

    return {
        title,
        component:
            <Layout>
                <ServicePlanPayment id={planId} userType={userType} />
            </Layout>
    };
}
